import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'react-jss';
import { PerformanceMarkerProvider } from '@bingads-webui-campaign-react/performance-marker-provider';
import { withComponentErrorLogging } from '@bingads-webui-campaign-react/global-error-options';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { StepWizard } from '@bingads-webui-campaign-react/step-wizard';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { MmpFetchProvider } from '@bingads-webui-campaign-react/xandr-campaign';
import { XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS } from '../xandr-video-campaign-crud-scenarios';

const getStyles = () => ({
  '@global': {
    '.app-shell .app-content-body': {
      // need to override the style since ad-group creation page shell inserts footer.
      overflow: 'hidden',
      flexShrink: '1!important',
    },
  },
});

const XandrVideoAdGroupCreationPageImpl = ((props) => {
  const routeToNavigateToWhenDone = getRoutePathById(props.siteMap, 'adgroups');

  return (
    <PerformanceMarkerProvider
      name={XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_AD_GROUP_CREATION.scenarioName}
      instrumentation={props.instrumentation}
      immediateDone
    >
      <MmpFetchProvider>
        <StepWizard
          wizardScenario={XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_AD_GROUP_CREATION}
          routeToNavigateToWhenDone={routeToNavigateToWhenDone}
          {...props}
          extraStepsData={{
            currentCampaign: props.currentCampaign,
          }}
        />
      </MmpFetchProvider>
    </PerformanceMarkerProvider>
  );
});

XandrVideoAdGroupCreationPageImpl.propTypes = {
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
  instrumentation: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
};

export const XandrVideoAdGroupCreationPage = withSiteMap(withTheme(withInstrumentation(withComponentErrorLogging(
  withDefaultStyles(XandrVideoAdGroupCreationPageImpl, getStyles),
  XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_AD_GROUP_CREATION.scenarioName
))));
